// import { axiosPrivate } from '../apis/axios'
// import { useEffect } from 'react'
// import useRefreshToken from './useRefreshToken'
// import useAuth from './useAuth'
// import gs1Instance from '../migration-api/api-index'

// const useAxiosPrivate = () => {
//   const refresh = useRefreshToken()
//   const { auth } = useAuth()

//   console.log('auth_token', auth)

//   useEffect(() => {
//     const requestIntercept = gs1Instance.interceptors.request.use(
//       config => {
//         if (!config.headers['authorization'] && auth?.accessToken) {
//           config.headers['authorization'] = `Bearer ${auth.accessToken}`
//         }

//         if (auth?.providerToken) {
//           config.headers['provider-token'] = auth.providerToken
//         }

//         return config
//       },
//       error => Promise.reject(error)
//     )

//     const responseIntercept = gs1Instance.interceptors.response.use(
//       response => response,
//       async error => {
//         const prevRequest = error?.config

//         // Only refresh on 401 (unauthorized / expired token)

//         // if (
//         // 	(error?.response?.status === 401 ||
//         // 		error?.response?.status === 403) &&
//         // 	!prevRequest?._retry &&
//         // 	auth?.refreshToken
//         // ) {
//         // 	prevRequest._retry = true;

//         // 	try {
//         // 		const newAccessToken = await refresh();

//         // 		prevRequest.headers[
//         // 			"authorization"
//         // 		] = `Bearer ${newAccessToken}`;

//         // 		return axiosPrivate(prevRequest);
//         // 	} catch (refreshError) {
//         // 		// Refresh failed → logout or redirect
//         // 		return Promise.reject(refreshError);
//         // 	}
//         // }

//         if (
//           error?.response?.status === 401 &&
//           !prevRequest?._retry &&
//           auth?.refreshToken
//         ) {
//           return Promise.reject(error)
//         }
//       }
//     )

//     return () => {
//       gs1Instance.interceptors.request.eject(requestIntercept)
//       gs1Instance.interceptors.response.eject(responseIntercept)
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [auth?.accessToken, auth?.refreshToken, refresh])

//   return gs1Instance
// }

// export default useAxiosPrivate


import { useEffect } from 'react'
import useRefreshToken from './useRefreshToken'
import useAuth from './useAuth'
import gs1Instance from '../migration-api/api-index'

const useAxiosPrivate = () => {
  const refresh = useRefreshToken()
  const { auth } = useAuth()

  useEffect(() => {
    const requestIntercept = gs1Instance.interceptors.request.use(
      config => {
        if (!config.headers['authorization'] && auth?.accessToken) {
          config.headers['authorization'] = `Bearer ${auth.accessToken}`
        }

        if (auth?.providerToken) {
          config.headers['provider-token'] = auth.providerToken
        }

        return config
      },
      error => Promise.reject(error)
    )

    const responseIntercept = gs1Instance.interceptors.response.use(
      response => response,
      async error => {
        const prevRequest = error?.config

        // 🔴 ONLY refresh on 401
        if (
          error?.response?.status === 401 &&
          !prevRequest?._retry &&
          auth?.refreshToken
        ) {
          prevRequest._retry = true

          try {
            const newAccessToken = await refresh()

            prevRequest.headers['authorization'] =
              `Bearer ${newAccessToken}`

            // 🔴 RETRY WITH SAME INSTANCE
            return gs1Instance(prevRequest)
          } catch (refreshError) {
            // Refresh failed → let PersistLogin handle logout
            return Promise.reject(refreshError)
          }
        }

        // 🔴 DO NOTHING SPECIAL ON 403 (FORBIDDEN)
        if (error?.response?.status === 403) {
          console.warn('Forbidden: no permission for this endpoint')
          return Promise.reject(error)
        }

        return Promise.reject(error)
      }
    )

    return () => {
      gs1Instance.interceptors.request.eject(requestIntercept)
      gs1Instance.interceptors.response.eject(responseIntercept)
    }
  }, [auth?.accessToken, auth?.refreshToken, refresh])

  // 🔴 MUST RETURN THE SAME INSTANCE YOU INTERCEPTED
  return gs1Instance
}

export default useAxiosPrivate

